/* NB: this file needs to be a CJS module because next-i18next.config.js imports this module and is a CJS module. */

const lang = {
	NS_COMMON: 'common',
	NS_ARTICLE: 'article',
	NS_RECIPE: 'recipe',
	NS_RATINGS: 'ratings',
};

module.exports = lang;
